import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

const SiteCtx = createContext(null);

/** Jeton de prévisualisation extrait d'une route /preview/<jeton>[/*]. */
export function previewTokenFromPath(pathname) {
    const m = pathname.match(/^\/preview\/([a-f0-9]{32,})/);
    return m ? m[1] : null;
}

export function SiteProvider({ children }) {
    const [data, setData] = useState(null);
    const [failed, setFailed] = useState(false);
    const location = useLocation();
    const previewToken = previewTokenFromPath(location.pathname);

    const refresh = useCallback(() => {
        return api
            .get("/public/bootstrap", { params: previewToken ? { preview_token: previewToken } : {} })
            .then((r) => setData(r.data))
            .catch(() => setFailed(true));
    }, [previewToken]);

    useEffect(() => {
        setData(null);
        setFailed(false);
        refresh();
    }, [refresh]);

    return <SiteCtx.Provider value={{ data, failed, refresh, previewToken }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);

export function PageTracker() {
    const location = useLocation();
    useEffect(() => {
        if (location.pathname.startsWith("/admin") || location.pathname.startsWith("/preview")) return;
        const consent = localStorage.getItem("bc_consent");
        if (consent !== "yes") return;
        let vid = localStorage.getItem("bc_vid");
        if (!vid) {
            vid = crypto.randomUUID();
            localStorage.setItem("bc_vid", vid);
        }
        api
            .post("/public/track", { path: location.pathname + location.hash, visitor_id: vid, consent: true })
            .catch(() => {});
    }, [location]);
    return null;
}
